import React from 'react';
import { useTranslation } from '../../hooks/useTranslation';
import i18n from '../../i18n';
import { dataShape } from '../../shapes/dataShape';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import BarChart from '../../components/BarChart';
import './SelfReflection.scss';
import { CONSTANTS } from '../../constants';
import { getSectionSummary } from '../getSectionSummary';
import { getDates } from '../getDates';

function SelfReflection({ data }) {
	const { t } = useTranslation();
	const { baselineDate, exitDate } = getDates(data);
	const { baseline: dataSelfReflectionBaseline, exit: dataSelfReflectionCurrent } = getSectionSummary(data, CONSTANTS.SELF_REFLECTION.key);
	const { baseline: dataSelfInsightBaseline, exit: dataSelfInsightCurrent } = getSectionSummary(data, CONSTANTS.SELF_INSIGHT.key);

	const { color, pageNumber } = CONSTANTS.SELF_REFLECTION;

	return (
		<article className={`self-reflection-insight ${i18n.language === 'fr-CA' && 'french'}`}>
			<section className="page">
				<Header title={t('pages:selfReflection.title')} color={color} />
				<div className="report-content">
					<div className="row challenge-dates">
						<div className="col-half">
							<h3>{t('common:baseline')}: ({baselineDate})</h3>
							<div style={{ height: 50, width: 300 }}>
								<BarChart data={dataSelfReflectionBaseline} marginLeft={95} scaleOnBottom={false} />
								<BarChart data={dataSelfInsightBaseline} marginLeft={95} scaleOnBottom={false} />
							</div>
						</div>
						<div className="col-half">
							<h3>{t('common:current')}: ({exitDate})</h3>
							<div style={{ height: 50, width: 300 }}>
								<BarChart data={dataSelfReflectionCurrent} marginLeft={95} scaleOnBottom={false} />
								<BarChart data={dataSelfInsightCurrent} marginLeft={95} scaleOnBottom={false} />
							</div>
						</div>
					</div>
					<div className="overview">
						<h3>{t('common:overview')}</h3>
						<p>
							{t('pages:selfReflection.selfReflectionAndSelfInsightAreBoth')}
						</p>
						<p>
							{t('pages:selfReflection.selfReflectionAndSelfInsightMayOccur')}
						</p>
						<p>
							{t('pages:selfReflection.aMoreRecentStudy')}
						</p>
					</div>
				</div>
				<div className="bottom">
					<div className="row">
						<div className="col-half">
							<h3>{t('pages:selfReflection.checkingInAndSelfReflection')}</h3>
							<p>
								{t('pages:selfReflection.checkingInEncouragesYouToReflect')}
							</p>
						</div>
						<div className="col-half reflection">
							<h3>{t('common:reflection')}</h3>
							<p>
								{t('pages:selfReflection.considerYourOwnCheckins')}
							</p>
						</div>
					</div>
				</div>
				<Footer pageNumber={pageNumber} />
			</section>
		</article>
	);
}

SelfReflection.propTypes = {
	data: dataShape.isRequired,
};

export default SelfReflection;
